export default function buildBarConfig(legendData, data, color) {
  return {
    grid: {
      left: '3%',
      right: '12%',
      bottom: '3%',
      containLabel: true
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    color: [color],
    xAxis: {
      type: 'value',
      axisLabel: {
        formatter: '{value} 吨'
      }
    },
    yAxis: {
      type: 'category',
      data: legendData,
      min: function (value) {
        return value.min * 1.1;
      }
    },
    series: [
      {
        name: '碳排放',
        type: 'bar',
        data: data,
        label: {
          show: true,
          position: 'right',
          formatter: '{c} 吨'
        }
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/config/chart/config_cross_bar.js